function TheGame() {
    /*////////////////////////////////////////////////////////////////////////////////
//standard game logic
     */
    this.gameId = _ndok_app_id;
    this.backgroundcolor = 0xd8bad4;
    this.positionGameItems = positionGameItems;
    this.initGame = initGame;
    this.resetGame = resetGame;
    this.stopGame = stopGame;
    this.startGame = startGame;
    this.cycleGame = cycleGame;
    var gameData = {};

    var sprites;

    var counter;
    var itemsPositions = [{ x: 628, y: 359, w: 34, h: 34, n: "n_05" }, { x: 597, y: 253, w: 34, h: 34, n: "n_04" }, { x: 525, y: 148, w: 34, h: 34, n: "n_03" }, { x: 390, y: 105, w: 34, h: 34, n: "n_02" }, { x: 244, y: 138, w: 34, h: 34, n: "n_01" }, { x: 549, y: 441, w: 34, h: 34, n: "n_06" }, { x: 274, y: 292, w: 161, h: 129, n: "pesce" }, { x: 491, y: 413, w: 124, h: 98, n: "btn_06" }, { x: 568, y: 317, w: 124, h: 98, n: "btn_05" }, { x: 547, y: 214, w: 124, h: 98, n: "btn_04" }, { x: 476, y: 117, w: 124, h: 99, n: "btn_03" }, { x: 336, y: 65, w: 124, h: 104, n: "btn_02" }, { x: 195, y: 100, w: 120, h: 96, n: "btn_01" }, { x: 578, y: 322, w: 116, h: 92, n: "pesce_05" }, { x: 555, y: 220, w: 112, h: 90, n: "pesce_04" }, { x: 499, y: 411, w: 114, h: 90, n: "pesce_06" }, { x: 184, y: 59, w: 523, h: 470, n: "boccia" }];
    var itemsPositionsObject = { n_05: { x: 628, y: 359, w: 34, h: 34, n: "n_05" }, n_04: { x: 597, y: 253, w: 34, h: 34, n: "n_04" }, n_03: { x: 525, y: 148, w: 34, h: 34, n: "n_03" }, n_02: { x: 390, y: 105, w: 34, h: 34, n: "n_02" }, n_01: { x: 244, y: 138, w: 34, h: 34, n: "n_01" }, n_06: { x: 549, y: 441, w: 34, h: 34, n: "n_06" }, pesce: { x: 274, y: 292, w: 161, h: 129, n: "pesce" }, btn_06: { x: 491, y: 413, w: 124, h: 98, n: "btn_06" }, btn_05: { x: 568, y: 317, w: 124, h: 98, n: "btn_05" }, btn_04: { x: 547, y: 214, w: 124, h: 98, n: "btn_04" }, btn_03: { x: 476, y: 117, w: 124, h: 99, n: "btn_03" }, btn_02: { x: 336, y: 65, w: 124, h: 104, n: "btn_02" }, btn_01: { x: 195, y: 100, w: 120, h: 96, n: "btn_01" }, pesce_05: { x: 578, y: 322, w: 116, h: 92, n: "pesce_05" }, pesce_04: { x: 555, y: 220, w: 112, h: 90, n: "pesce_04" }, pesce_06: { x: 499, y: 411, w: 114, h: 90, n: "pesce_06" }, boccia: { x: 184, y: 59, w: 523, h: 470, n: "boccia" } };

    var gameScene;



    /**
     * CORE GAME LOGIC
     */
    function initGame() {
        sprites = game.sprites;

        positionGameItems();

        makeScenes();
        makeCounter();
        document.addEventListener(GameEvents.ANSWER_OK, onAnswerOk, true);
        document.addEventListener(GameEvents.ANSWER_WRONG, onAnswerWrong, true);
    }



    function resetGame() {
        resetItems();
        prepareData();
    }

    function startGame() {
        scenesContainer.removeChildren(0, scenesContainer.children.length);
        scenesContainer.addChild(gameData.scene.container);
        counter.setText(gameData.currentItem + "/" + gameData.numItems);
        cycleGame();
    }

    function cycleGame() {

        if (gameData.currentItem < gameData.numItems) {
            renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        } else {

            setTimeout(end, 800);
        }

    }

    function end() {
        stopGame();
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_END_GAME));
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        loopSequence = [renderOnce];
    }

    function stopGame() {
        gameData.scene.clear();
    }

    function prepareData() {
        gameData.numItems = 3;
        gameData.currentItem = 0;
        gameData.scene = gameScene;
        gameData.scene.reset();
    }


    function makeScenes() {
        scenesContainer = new Container();
        scenesContainer.position.set(335, 0);
        game.gameContainer.addChild(scenesContainer);

        gameScene = new Scene('pesci', itemsPositionsObject);

    }

    function makeCounter() {
        counter = new ItemsCounter();
        game.gameContainer.addChild(counter.container);
    }


    function positionGameItems() {
        sprites.btn_gioca.x = 442;
        sprites.btn_gioca.y = 442;
        sprites.btn_gioca.alpha = 0;
    }

    function resetItems() {

    }

    /**
     * GAME LOGIC
     */
    function onAnswerOk(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.GREEN_LIGHT));
        gameData.currentItem++;
        counter.setText(gameData.currentItem + "/" + gameData.numItems);

    }

    function onAnswerWrong(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.RED_LIGHT));
    }
}

function Scene(sceneName, positions) {
    var name = sceneName;
    this.name = name;
    this.reset = reset;
    this.clear = clear;
    var animating;
    var currentState;
    this.setState = setState;

    //
    var tl = new TimelineMax();
    //
    var container = new Container();
    this.container = container;

    var buttonsContainer = new Container();
    container.addChild(buttonsContainer);
    buttonsContainer.interactive = true;
    buttonsContainer.on('pointertap', onClick);

    renderer.view.addEventListener(GameEvents.EVENT_CYCLE_GAME, cycled);

    var itemsNames = ['01', '02', '03', '04', '05', '06'];
    var sceneElements = {};
    var fishNames = ['pesce_04', 'pesce_05', 'pesce_06'];
    var currentfishName;

    var boccia = game.sprites.boccia;
    boccia.position.set(positions.boccia.x, positions.boccia.y);
    container.addChild(boccia);



    initScene();

    function initScene() {
        var i;
        var itemName;
        var spriteItem;
        var pos;
        for (i = 0; i < itemsNames.length; i++) {
            itemName = itemsNames[i];
            spriteItem = game.sprites[itemName];
            pos = positions["n_" + itemName];
            spriteItem.position.set(pos.x, pos.y);

            container.addChild(spriteItem);
            sceneElements["n_" + itemName] = spriteItem;
            //recycle
            pos = positions["btn_" + itemName];
            var rect = new PIXI.Rectangle(0, 0, pos.w, pos.h);
            spriteItem = new Sprite(spriteItem.texture);
            spriteItem.position.set(pos.x, pos.y);
            spriteItem.width = pos.w;
            spriteItem.height = pos.h;

            spriteItem.interactive = true;
            spriteItem.buttonMode = true;
            buttonsContainer.addChild(spriteItem);
            sceneElements["btn_" + itemName] = spriteItem;
        }
        for (i = 0; i < fishNames.length; i++) {
            itemName = fishNames[i];
            spriteItem = game.sprites[itemName];
            pos = positions[itemName];
            spriteItem.position.set(pos.x, pos.y);
            spriteItem.width = pos.w;
            spriteItem.height = pos.h;
            // spriteItem.visible = false;
            container.addChild(spriteItem);
            sceneElements[itemName] = spriteItem;
            var bigOne = new Sprite(spriteItem.texture);
            bigOne.position.set(positions.pesce.x, positions.pesce.y);
            container.addChild(bigOne);
            sceneElements["big_" + itemName] = bigOne;
            bigOne.visible = false;

        }
    }


    function clear() {


    }

    function reset() {
        fishNames = _.shuffle(fishNames);
        resetNumbers();
        resetFishes();
        setState('newFish');
    }

    function resetNumbers() {
        var i;
        var itemName;
        for (i = 0; i < itemsNames.length; i++) {
            itemName = itemsNames[i];
            sceneElements["n_" + itemName].alpha = 0;
        }
    }

    function resetFishes() {
        var i;
        var itemName;
        for (i = 0; i < fishNames.length; i++) {
            itemName = fishNames[i];
            sceneElements[itemName].alpha = 0;
            sceneElements["big_" + itemName].visible = false;
        }
    }
    //TODO::::::::::::::::::::::::::
    function cycled() {
        setState('ready');
    }

    function setState(state) {

        switch (state) {
            case 'newFish':
                resetNumbers();
                resetFishes();

                fishNames.push(fishNames.shift());
                currentfishName = fishNames[0];
                sceneElements["big_" + currentfishName].visible = true;
                sceneElements["big_" + currentfishName].alpha = 1;
                break;
            case 'ready':

                break;
            case 'animating':


                break;
        }
        currentState = state;

    }

    function onClick(e) {
        var i;
        if (currentState === "ready") {
            var btnName = "";
            for (i = 0; i < itemsNames.length; i++) {
                if (sceneElements["btn_" + itemsNames[i]] === e.target) {
                    btnName = itemsNames[i];
                }
            }

            if (btnName === "") {
                return false;
            }
            var ok = 'pesce_' + btnName === currentfishName;

            if (ok) {

                renderer.view.dispatchEvent(new Event('answerOk'));
                tl.to(sceneElements[currentfishName], 0.50, { pixi: { alpha: 1 } }).to(sceneElements["big_" + currentfishName], 1, { pixi: { alpha: 0 } }, 0.25).addCallback(okComplete, "+=1");
                loopSequence = [renderAlways];
                setState('animating');
                loopSequence = [renderAlways];
            } else {
                renderer.view.dispatchEvent(new Event('answerWrong'));

                tl.to(sceneElements['n_' + btnName], 0.20, { pixi: { alpha: 1 }, repeat: 4, yoyo: true }).addCallback(animationComplete, "+=1", [sceneElements['n_' + btnName]]);
                loopSequence = [renderAlways];
                setState('animating');
            }


        }

    }

    function okComplete() {

        setState('newFish');
        theGame.cycleGame();
        loopSequence = [renderOnce];


    }

    function animationComplete(sprite) {
        // sprite.alpha = 0;       
        theGame.cycleGame();
        loopSequence = [renderOnce];
        setState('ready');
    }
}